import { render, staticRenderFns } from "./_facetValue.vue?vue&type=template&id=b503ee3a&"
import script from "./_facetValue.vue?vue&type=script&lang=js&"
export * from "./_facetValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBreadCrumb.vue').default,AppBackToTopButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBackToTopButton.vue').default})
